import ExternalLayout from "@3gaam/capp/src/view/layout/externalLayout";
import main from "@3gaam/capp/src/view/layout/main";
import { lazy } from "react";
import { ROUTES } from "../constants";

// Auth
const Login = lazy(() => import("../view/pages/auth/login"));
//
const ConsulteeApplicants = lazy(() =>
  import("../view/pages/consulteeApplicants"),
);
const Chat = lazy(() => import("../view/pages/chat"));
const ApplicantProducts = lazy(() => import("../view/pages/applicantProducts"));
const Payment = lazy(() => import("../view/pages/payment"));
// Profile
const ConsultantsUsers = lazy(() =>
  import("../view/pages/iframes/consultantsUsers"),
);
const TinyCRMEventRequest = lazy(() =>
  import("../view/pages/iframes/tinyCRMEventRequest"),
);
const Routine = lazy(() => import("../view/pages/iframes/routine"));
const TinyCRMReport = lazy(() => import("../view/pages/iframes/tinyCRMReport"));
const UserProduct = lazy(() => import("../view/pages/iframes/userProduct"));
const CounselorPaymentDetails = lazy(() =>
  import("../view/pages/iframes/counselorPaymentDetails"),
);
const UserRates = lazy(() => import("../view/pages/iframes/userRates"));
const DeleteAccount = lazy(() => import("../view/pages/deleteAccount"));

const mainRoutes = [
  // auth pages
  {
    title: ROUTES.LOGIN.TITLE,
    path: ROUTES.LOGIN.PATH,
    component: Login,
  },
  {
    title: ROUTES.CONSULTEE_APPLICANTS.TITLE,
    path: ROUTES.CONSULTEE_APPLICANTS.PATH,
    component: ConsulteeApplicants,
    layout: main,
    loginRequired: true,
  },
  {
    title: ROUTES.CHAT.TITLE,
    path: ROUTES.CHAT.PATH,
    component: Chat,
    loginRequired: true,
    subRoutes: [
      {
        title: ROUTES.CHAT.TITLE,
        path: ":chatId",
        component: Chat,
        loginRequired: true,
      },
    ],
  },
  {
    title: ROUTES.ACTIVE_PRODUCTS.TITLE,
    path: ROUTES.ACTIVE_PRODUCTS.PATH,
    component: ApplicantProducts,
    loginRequired: true,
    layout: ExternalLayout,
    subRoutes: [
      {
        title: ROUTES.ACTIVE_PRODUCTS.TITLE,
        path: ":applicantId",
        component: ApplicantProducts,
        loginRequired: true,
      },
    ],
  },
  // iframes
  {
    title: ROUTES.CONSULTANTS_USERS.TITLE,
    path: ROUTES.CONSULTANTS_USERS.PATH,
    component: ConsultantsUsers,
    layout: ExternalLayout,
    loginRequired: true,
  },
  {
    title: ROUTES.CRMEVENT_REQUEST.TITLE,
    path: ROUTES.CRMEVENT_REQUEST.PATH,
    component: TinyCRMEventRequest,
    layout: ExternalLayout,
    loginRequired: true,
  },
  {
    title: ROUTES.ROUTINES.TITLE,
    path: ROUTES.ROUTINES.PATH,
    component: Routine,
    layout: ExternalLayout,
    loginRequired: true,
  },
  {
    title: ROUTES.USER_PRODUCT.TITLE,
    path: ROUTES.USER_PRODUCT.PATH,
    component: UserProduct,
    layout: ExternalLayout,
    loginRequired: true,
  },
  {
    title: ROUTES.CRMEVENT_REPORT.TITLE,
    path: ROUTES.CRMEVENT_REPORT.PATH,
    component: TinyCRMReport,
    layout: ExternalLayout,
    loginRequired: true,
  },
  {
    title: ROUTES.PAYMENT.TITLE,
    path: ROUTES.PAYMENT.PATH,
    component: Payment,
    layout: ExternalLayout,
    loginRequired: true,
  },
  {
    title: ROUTES.PAYMENT_DETAILS.TITLE,
    path: ROUTES.PAYMENT_DETAILS.PATH,
    component: CounselorPaymentDetails,
    layout: ExternalLayout,
    loginRequired: true,
  },
  {
    title: ROUTES.USER_RATES.TITLE,
    path: ROUTES.USER_RATES.PATH,
    component: UserRates,
    layout: ExternalLayout,
    loginRequired: true,
  },
  // Others
  {
    redirect: true,
    path: "*",
    to: ROUTES.CONSULTEE_APPLICANTS.PATH,
    navbarName: "Redirect",
  },
  {
    title: ROUTES.DELETE_ACCOUNT.TITLE,
    path: ROUTES.DELETE_ACCOUNT.PATH,
    component: DeleteAccount,
    layout: ExternalLayout,
    loginRequired: true,
  },
];

export default mainRoutes;
